/**
 * Remove access token from url
 */
export default defineNuxtRouteMiddleware((to) => {
  const { name, params, query } = to;

  if (query.access_token || query.access_expire || query.access_delay) {
    const localStorage = useLocalStorage();
    localStorage.set("access", {
      token: query.access_token ?? "",
      exp: query.access_expire ? query.access_expire * 1000 : 0,
      delay: query.access_delay ? query.access_delay * 1000 : 0,
    });

    delete query.access_token;
    delete query.access_expire;
    delete query.access_delay;

    return navigateTo({ name, params, query });
  }
});
